export const getServiceBusSubscriptionDetails = (state) =>
  state.deviceNotification.serviceBusSubscription;
